import { Contract, ProductTypeEN, VehicleDetails } from 'cpfr-common';
import { DefinitionList, DefinitionListItem, openInNewWindow } from '@cp-shared-19/frontend-ui';
import { Accordion, Button } from '@vwfs-bronson/bronson-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { emptyObjectOrAllValuesAreUndefined } from '../../../../utils';
import { ErrorNotification } from '../../../notifications/error/ErrorNotification';

export type VehicleDetailsProps = { contract: Contract; vehicleDetails?: VehicleDetails; isSMECustomer?: boolean };

export const VehicleDetailsComponent: React.FC<VehicleDetailsProps> = ({ contract, vehicleDetails, isSMECustomer }) => {
    const { t } = useTranslation('vehicle-details');
    const [isError, setIsError] = useState(false);

    const { isActive, productTypeEN, contractId } = contract;
    if (!vehicleDetails || isSMECustomer === undefined) {
        return null;
    }

    const privateItemList: DefinitionListItem[] = [
        {
            label: t('car-description'),
            value: vehicleDetails?.carDescription,
            testId: 'car-description',
        },
        {
            label: t('car-add-description'),
            value: vehicleDetails?.carAddDescription,
            testId: 'car-add-description',
        },
        {
            label: t('vin'),
            value: vehicleDetails?.vin,
            testId: 'vin',
        },
        {
            label: t('license-plate'),
            value: vehicleDetails?.licensePlate,
            testId: 'license-plate',
        },
    ];

    const smeItemList: DefinitionListItem[] = [
        {
            label: t('car-description'),
            value: vehicleDetails?.carDescription,
            testId: 'car-description',
        },
        {
            label: t('car-add-description'),
            value: vehicleDetails?.carAddDescription,
            testId: 'car-add-description',
        },
        {
            label: t('vin'),
            value: vehicleDetails?.vin,
            testId: 'vin',
        },
        {
            label: t('license-plate'),
            value: vehicleDetails?.licensePlate,
            testId: 'license-plate',
        },
    ];
    const getItemList = (): DefinitionListItem[] => {
        let itemList: DefinitionListItem[];
        if (isSMECustomer) {
            itemList = smeItemList;
        } else {
            itemList = privateItemList;
        }
        const outputList = itemList.filter(({ value }) => !!value);
        if (emptyObjectOrAllValuesAreUndefined(vehicleDetails) || !outputList.length) {
            setIsError(true);
        }
        return outputList;
    };

    return (
        <Accordion.Item
            title={t('title')}
            titleLevel={4}
            contentClassName={'u-pr-none'}
            id={`vehicle-details-${contractId}`}
        >
            {isError ? (
                <ErrorNotification testId={'not-found-error'} headline={t('error.headline')} text={t('error.text')} />
            ) : (
                <div>
                    <DefinitionList split={true} list={getItemList()} />
                </div>
            )}
            <>
                {isSMECustomer &&
                    !isActive &&
                    (productTypeEN === ProductTypeEN.OPERATIVE_LEASING || productTypeEN === ProductTypeEN.VDL) && (
                        <Button
                            icon="semantic-forward"
                            iconReversed
                            link
                            secondary
                            small
                            onClick={() => openInNewWindow(t('consult-export-report-url'))}
                            testId={'consult-button'}
                        >
                            {t('consult-export-report')}
                        </Button>
                    )}
            </>
        </Accordion.Item>
    );
};
